/* Version: 3.5.155 */
'use client';
var TOGGLE_VARIANT = {
  LARGE: 'large',
  SMALL: 'small'
};

export { TOGGLE_VARIANT };
